import { jssPreset as Nt, createTheme as Vt } from "@material-ui/core";
import xr from "react";
import { ChevronDownLightIcon as ke, ForbiddenLightIcon as Ht, InfoStatusLightIcon as Gt, CheckLightIcon as Ut, WarningStatusLightIcon as Jt, CrossLightIcon as Cr } from "@global-engineering-shared/gweb-global-icons";
const Yt = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1440
  }
}, qt = "#ffffff", Kt = "#000000", Xt = "#f8f8f8", Zt = "#dadada", Qt = "#c2c2c2", en = "#aaaaaa", rn = "#919191", tn = "#7c7c7c", nn = "#686868", on = "#555555", an = "#434343", sn = "#323232", cn = "#232323", un = "#D5D5D5", ln = "#AAAAAA", dn = "#303030", fn = "#616161", hn = "#f9f9f9", Or = "#f4f4f4", pn = "#e9e9e9", Tr = "#dedede", gn = "#d3d3d3", vn = "#c8c8c8", Mr = "#bdbdbd", yn = "#b3b3b3", mn = "#a7a7a7", bn = "#9c9c9c", we = "#919191", Ee = "#747474", Rn = "#575757", Sn = "#3a3a3a", kr = "#1d1d1d", wr = "#F2F7FC", Pn = "#e5f0f9", xn = "#cde1f3", Cn = "#b3d2ed", On = "#9bc3e7", Tn = "#81b4e1", Er = "#68a6dc", Mn = "#5097d6", kn = "#3688d0", wn = "#1e79ca", Ar = "#046ac4", En = "#03559d", _r = "#024076", An = "#022a4e", Ir = "#f4f8f5", _n = "#e8f1ea", In = "#d2e4d7", Dn = "#bbd6c2", Ln = "#a5c9ae", Fn = "#8ebc9a", Dr = "#78af86", jn = "#62a272", Bn = "#4b945d", $n = "#35874a", Lr = "#1e7935", Wn = "#18612a", Fr = "#124920", zn = "#0c3015", jr = "#fcf5f5", Nn = "#faeaea", Vn = "#f5d6d6", Hn = "#f0c1c1", Gn = "#ebadad", Un = "#e69999", Br = "#e18585", Jn = "#dc7171", Yn = "#d75c5c", qn = "#d24848", $r = "#cd3333", Kn = "#a42929", Wr = "#7b1f1f", Xn = "#521414", zr = "#fef8f3", Zn = "#fdf0e7", Qn = "#fde2d0", ei = "#fbd4b7", ri = "#fac6a0", ti = "#f9b788", Nr = "#f8a971", ni = "#f79b5a", ii = "#f58d41", oi = "#f57f2a", Vr = "#f37012", ai = "#c25a0e", Hr = "#92430b", si = "#612d07", Gr = "#f5f6fa", ci = "#eaedf5", ui = "#d7dceb", li = "#c2cbe1", di = "#aebad8", fi = "#9aa8ce", hi = "#8697c4", pi = "#7286bb", Ur = "#5d75b1", gi = "#4a64a7", Jr = "#35529d", vi = "#2a427e", Yr = "#20315e", yi = "#15213f", mi = "#fdf6fa", bi = "#fbedf4", Ri = "#f7dbea", Si = "#f3c9e0", Pi = "#efb7d6", xi = "#eba5cb", Ci = "#e793c1", Oi = "#e382b7", Ti = "#df6fad", Mi = "#db5ea3", ki = "#d74b98", wi = "#ac3c7a", Ei = "#812d5b", Ai = "#561e3d", qr = "#f3f9fb", _i = "#e7f3f7", Ii = "#cfe7f0", Di = "#b7dbe8", Li = "#9fcfe1", Fi = "#87c3da", Kr = "#87c3da", ji = "#58accc", Bi = "#409fc4", $i = "#2894bd", Xr = "#1087b5", Wi = "#0d6c91", Zr = "#0a516d", zi = "#063648", Ni = Or, Vi = Tr, Hi = Mr, Gi = Ee, Ui = kr, Ji = Ee, Yi = we, qi = we, Ki = Jr, Xi = Ur, Zi = Yr, Qi = Gr, eo = Dr, ro = Lr, to = Fr, no = Ir, io = Br, oo = $r, ao = Wr, so = jr, co = Nr, uo = Vr, lo = Hr, fo = zr, ho = Er, po = Ar, go = _r, vo = wr, yo = Kr, mo = Xr, bo = Zr, Ro = qr, a = {
  white: qt,
  black: Kt,
  gray50: hn,
  gray100: Or,
  gray200: pn,
  gray300: Tr,
  gray400: gn,
  gray500: vn,
  gray600: Mr,
  gray700: yn,
  gray800: mn,
  gray900: bn,
  gray1000: we,
  gray1200: Ee,
  gray1400: Rn,
  gray1600: Sn,
  gray1800: kr,
  grey50: Xt,
  grey100: Zt,
  grey200: Qt,
  grey300: en,
  grey400: rn,
  grey500: tn,
  grey600: nn,
  grey700: on,
  grey800: an,
  grey900: sn,
  grey1000: cn,
  greyA100: un,
  greyA200: ln,
  greyA400: dn,
  greyA700: fn,
  blue50: wr,
  blue100: Pn,
  blue200: xn,
  blue300: Cn,
  blue400: On,
  blue500: Tn,
  blue600: Er,
  blue700: Mn,
  blue800: kn,
  blue900: wn,
  blue1000: Ar,
  blue1200: En,
  blue1400: _r,
  blue1600: An,
  green50: Ir,
  green100: _n,
  green200: In,
  green300: Dn,
  green400: Ln,
  green500: Fn,
  green600: Dr,
  green700: jn,
  green800: Bn,
  green900: $n,
  green1000: Lr,
  green1200: Wn,
  green1400: Fr,
  green1600: zn,
  red50: jr,
  red100: Nn,
  red200: Vn,
  red300: Hn,
  red400: Gn,
  red500: Un,
  red600: Br,
  red700: Jn,
  red800: Yn,
  red900: qn,
  red1000: $r,
  red1200: Kn,
  red1400: Wr,
  red1600: Xn,
  orange50: zr,
  orange100: Zn,
  orange200: Qn,
  orange300: ei,
  orange400: ri,
  orange500: ti,
  orange600: Nr,
  orange700: ni,
  orange800: ii,
  orange900: oi,
  orange1000: Vr,
  orange1200: ai,
  orange1400: Hr,
  orange1600: si,
  violet50: Gr,
  violet100: ci,
  violet200: ui,
  violet300: li,
  violet400: di,
  violet500: fi,
  violet600: hi,
  violet700: pi,
  violet800: Ur,
  violet900: gi,
  violet1000: Jr,
  violet1200: vi,
  violet1400: Yr,
  violet1600: yi,
  magenta50: mi,
  magenta100: bi,
  magenta200: Ri,
  magenta300: Si,
  magenta400: Pi,
  magenta500: xi,
  magenta600: Ci,
  magenta700: Oi,
  magenta800: Ti,
  magenta900: Mi,
  magenta1000: ki,
  magenta1200: wi,
  magenta1400: Ei,
  magenta1600: Ai,
  cyan50: qr,
  cyan100: _i,
  cyan200: Ii,
  cyan300: Di,
  cyan400: Li,
  cyan500: Fi,
  cyan600: Kr,
  cyan700: ji,
  cyan800: Bi,
  cyan900: $i,
  cyan1000: Xr,
  cyan1200: Wi,
  cyan1400: Zr,
  cyan1600: zi,
  neutralLighter: Ni,
  neutralLight: Vi,
  neutralBase: Hi,
  neutralDark: Gi,
  successLight: eo,
  successMain: ro,
  successDark: to,
  successContrast: no,
  errorLight: io,
  errorMain: oo,
  errorDark: ao,
  errorContrast: so,
  warningLight: co,
  warningMain: uo,
  warningDark: lo,
  warningContrast: fo,
  infoLight: Xi,
  infoMain: Ki,
  infoDark: Zi,
  infoContrast: Qi,
  primaryLight: ho,
  primaryMain: po,
  primaryDark: go,
  primaryContrast: vo,
  secondaryLight: yo,
  secondaryMain: mo,
  secondaryDark: bo,
  secondaryContrast: Ro,
  textPrimary: Ui,
  textSecondary: Ji,
  textDisabled: Yi,
  textHint: qi
};
function O() {
  return O = Object.assign ? Object.assign.bind() : function(i) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (i[e] = t[e]);
    }
    return i;
  }, O.apply(this, arguments);
}
var nr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
  return typeof i;
} : function(i) {
  return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
}, So = (typeof window > "u" ? "undefined" : nr(window)) === "object" && (typeof document > "u" ? "undefined" : nr(document)) === "object" && document.nodeType === 9, Po = process.env.NODE_ENV === "production";
function E(i, r) {
  if (!Po) {
    if (i)
      return;
    var t = "Warning: " + r;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
function X(i) {
  "@babel/helpers - typeof";
  return X = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, X(i);
}
function xo(i, r) {
  if (X(i) !== "object" || i === null)
    return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var e = t.call(i, r || "default");
    if (X(e) !== "object")
      return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(i);
}
function Co(i) {
  var r = xo(i, "string");
  return X(r) === "symbol" ? r : String(r);
}
function ir(i, r) {
  for (var t = 0; t < r.length; t++) {
    var e = r[t];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(i, Co(e.key), e);
  }
}
function Qr(i, r, t) {
  return r && ir(i.prototype, r), t && ir(i, t), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function me(i, r) {
  return me = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, n) {
    return e.__proto__ = n, e;
  }, me(i, r);
}
function et(i, r) {
  i.prototype = Object.create(r.prototype), i.prototype.constructor = i, me(i, r);
}
function or(i) {
  if (i === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function Oo(i, r) {
  if (i == null)
    return {};
  var t = {}, e = Object.keys(i), n, s;
  for (s = 0; s < e.length; s++)
    n = e[s], !(r.indexOf(n) >= 0) && (t[n] = i[n]);
  return t;
}
var To = {}.constructor;
function be(i) {
  if (i == null || typeof i != "object")
    return i;
  if (Array.isArray(i))
    return i.map(be);
  if (i.constructor !== To)
    return i;
  var r = {};
  for (var t in i)
    r[t] = be(i[t]);
  return r;
}
function rt(i, r, t) {
  i === void 0 && (i = "unnamed");
  var e = t.jss, n = be(r), s = e.plugins.onCreateRule(i, n, t);
  return s || (i[0] === "@" && process.env.NODE_ENV !== "production" && E(!1, "[JSS] Unknown rule " + i), null);
}
var ar = function(r, t) {
  for (var e = "", n = 0; n < r.length && r[n] !== "!important"; n++)
    e && (e += t), e += r[n];
  return e;
}, q = function(r) {
  if (!Array.isArray(r))
    return r;
  var t = "";
  if (Array.isArray(r[0]))
    for (var e = 0; e < r.length && r[e] !== "!important"; e++)
      t && (t += ", "), t += ar(r[e], " ");
  else
    t = ar(r, ", ");
  return r[r.length - 1] === "!important" && (t += " !important"), t;
};
function V(i) {
  return i && i.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function U(i, r) {
  for (var t = "", e = 0; e < r; e++)
    t += "  ";
  return t + i;
}
function Z(i, r, t) {
  t === void 0 && (t = {});
  var e = "";
  if (!r)
    return e;
  var n = t, s = n.indent, c = s === void 0 ? 0 : s, u = r.fallbacks;
  t.format === !1 && (c = -1 / 0);
  var f = V(t), p = f.linebreak, g = f.space;
  if (i && c++, u)
    if (Array.isArray(u))
      for (var v = 0; v < u.length; v++) {
        var k = u[v];
        for (var T in k) {
          var w = k[T];
          w != null && (e && (e += p), e += U(T + ":" + g + q(w) + ";", c));
        }
      }
    else
      for (var _ in u) {
        var W = u[_];
        W != null && (e && (e += p), e += U(_ + ":" + g + q(W) + ";", c));
      }
  for (var I in r) {
    var C = r[I];
    C != null && I !== "fallbacks" && (e && (e += p), e += U(I + ":" + g + q(C) + ";", c));
  }
  return !e && !t.allowEmpty || !i ? e : (c--, e && (e = "" + p + e + p), U("" + i + g + "{" + e, c) + U("}", c));
}
var Mo = /([[\].#*$><+~=|^:(),"'`\s])/g, sr = typeof CSS < "u" && CSS.escape, Ae = function(i) {
  return sr ? sr(i) : i.replace(Mo, "\\$1");
}, tt = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "style", this.isProcessed = !1;
    var s = n.sheet, c = n.Renderer;
    this.key = t, this.options = n, this.style = e, s ? this.renderer = s.renderer : c && (this.renderer = new c());
  }
  var r = i.prototype;
  return r.prop = function(e, n, s) {
    if (n === void 0)
      return this.style[e];
    var c = s ? s.force : !1;
    if (!c && this.style[e] === n)
      return this;
    var u = n;
    (!s || s.process !== !1) && (u = this.options.jss.plugins.onChangeValue(n, e, this));
    var f = u == null || u === !1, p = e in this.style;
    if (f && !p && !c)
      return this;
    var g = f && p;
    if (g ? delete this.style[e] : this.style[e] = u, this.renderable && this.renderer)
      return g ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, u), this;
    var v = this.options.sheet;
    return v && v.attached && process.env.NODE_ENV !== "production" && E(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, i;
}(), Re = /* @__PURE__ */ function(i) {
  et(r, i);
  function r(e, n, s) {
    var c;
    c = i.call(this, e, n, s) || this;
    var u = s.selector, f = s.scoped, p = s.sheet, g = s.generateId;
    return u ? c.selectorText = u : f !== !1 && (c.id = g(or(or(c)), p), c.selectorText = "." + Ae(c.id)), c;
  }
  var t = r.prototype;
  return t.applyTo = function(n) {
    var s = this.renderer;
    if (s) {
      var c = this.toJSON();
      for (var u in c)
        s.setProperty(n, u, c[u]);
    }
    return this;
  }, t.toJSON = function() {
    var n = {};
    for (var s in this.style) {
      var c = this.style[s];
      typeof c != "object" ? n[s] = c : Array.isArray(c) && (n[s] = q(c));
    }
    return n;
  }, t.toString = function(n) {
    var s = this.options.sheet, c = s ? s.options.link : !1, u = c ? O({}, n, {
      allowEmpty: !0
    }) : n;
    return Z(this.selectorText, this.style, u);
  }, Qr(r, [{
    key: "selector",
    set: function(n) {
      if (n !== this.selectorText) {
        this.selectorText = n;
        var s = this.renderer, c = this.renderable;
        if (!(!c || !s)) {
          var u = s.setSelector(c, n);
          u || s.replaceRule(c, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), r;
}(tt), ko = {
  onCreateRule: function(r, t, e) {
    return r[0] === "@" || e.parent && e.parent.type === "keyframes" ? null : new Re(r, t, e);
  }
}, ge = {
  indent: 1,
  children: !0
}, wo = /@([\w-]+)/, Eo = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "conditional", this.isProcessed = !1, this.key = t;
    var s = t.match(wo);
    this.at = s ? s[1] : "unknown", this.query = n.name || "@" + this.at, this.options = n, this.rules = new ae(O({}, n, {
      parent: this
    }));
    for (var c in e)
      this.rules.add(c, e[c]);
    this.rules.process();
  }
  var r = i.prototype;
  return r.getRule = function(e) {
    return this.rules.get(e);
  }, r.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, r.addRule = function(e, n, s) {
    var c = this.rules.add(e, n, s);
    return c ? (this.options.jss.plugins.onProcessRule(c), c) : null;
  }, r.replaceRule = function(e, n, s) {
    var c = this.rules.replace(e, n, s);
    return c && this.options.jss.plugins.onProcessRule(c), c;
  }, r.toString = function(e) {
    e === void 0 && (e = ge);
    var n = V(e), s = n.linebreak;
    if (e.indent == null && (e.indent = ge.indent), e.children == null && (e.children = ge.children), e.children === !1)
      return this.query + " {}";
    var c = this.rules.toString(e);
    return c ? this.query + " {" + s + c + s + "}" : "";
  }, i;
}(), Ao = /@container|@media|@supports\s+/, _o = {
  onCreateRule: function(r, t, e) {
    return Ao.test(r) ? new Eo(r, t, e) : null;
  }
}, ve = {
  indent: 1,
  children: !0
}, Io = /@keyframes\s+([\w-]+)/, Se = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var s = t.match(Io);
    s && s[1] ? this.name = s[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && E(!1, "[JSS] Bad keyframes name " + t)), this.key = this.type + "-" + this.name, this.options = n;
    var c = n.scoped, u = n.sheet, f = n.generateId;
    this.id = c === !1 ? this.name : Ae(f(this, u)), this.rules = new ae(O({}, n, {
      parent: this
    }));
    for (var p in e)
      this.rules.add(p, e[p], O({}, n, {
        parent: this
      }));
    this.rules.process();
  }
  var r = i.prototype;
  return r.toString = function(e) {
    e === void 0 && (e = ve);
    var n = V(e), s = n.linebreak;
    if (e.indent == null && (e.indent = ve.indent), e.children == null && (e.children = ve.children), e.children === !1)
      return this.at + " " + this.id + " {}";
    var c = this.rules.toString(e);
    return c && (c = "" + s + c + s), this.at + " " + this.id + " {" + c + "}";
  }, i;
}(), Do = /@keyframes\s+/, Lo = /\$([\w-]+)/g, Pe = function(r, t) {
  return typeof r == "string" ? r.replace(Lo, function(e, n) {
    return n in t ? t[n] : (process.env.NODE_ENV !== "production" && E(!1, '[JSS] Referenced keyframes rule "' + n + '" is not defined.'), e);
  }) : r;
}, cr = function(r, t, e) {
  var n = r[t], s = Pe(n, e);
  s !== n && (r[t] = s);
}, Fo = {
  onCreateRule: function(r, t, e) {
    return typeof r == "string" && Do.test(r) ? new Se(r, t, e) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(r, t, e) {
    return t.type !== "style" || !e || ("animation-name" in r && cr(r, "animation-name", e.keyframes), "animation" in r && cr(r, "animation", e.keyframes)), r;
  },
  onChangeValue: function(r, t, e) {
    var n = e.options.sheet;
    if (!n)
      return r;
    switch (t) {
      case "animation":
        return Pe(r, n.keyframes);
      case "animation-name":
        return Pe(r, n.keyframes);
      default:
        return r;
    }
  }
}, jo = /* @__PURE__ */ function(i) {
  et(r, i);
  function r() {
    return i.apply(this, arguments) || this;
  }
  var t = r.prototype;
  return t.toString = function(n) {
    var s = this.options.sheet, c = s ? s.options.link : !1, u = c ? O({}, n, {
      allowEmpty: !0
    }) : n;
    return Z(this.key, this.style, u);
  }, r;
}(tt), Bo = {
  onCreateRule: function(r, t, e) {
    return e.parent && e.parent.type === "keyframes" ? new jo(r, t, e) : null;
  }
}, $o = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = t, this.style = e, this.options = n;
  }
  var r = i.prototype;
  return r.toString = function(e) {
    var n = V(e), s = n.linebreak;
    if (Array.isArray(this.style)) {
      for (var c = "", u = 0; u < this.style.length; u++)
        c += Z(this.at, this.style[u]), this.style[u + 1] && (c += s);
      return c;
    }
    return Z(this.at, this.style, e);
  }, i;
}(), Wo = /@font-face/, zo = {
  onCreateRule: function(r, t, e) {
    return Wo.test(r) ? new $o(r, t, e) : null;
  }
}, No = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = t, this.style = e, this.options = n;
  }
  var r = i.prototype;
  return r.toString = function(e) {
    return Z(this.key, this.style, e);
  }, i;
}(), Vo = {
  onCreateRule: function(r, t, e) {
    return r === "@viewport" || r === "@-ms-viewport" ? new No(r, t, e) : null;
  }
}, Ho = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "simple", this.isProcessed = !1, this.key = t, this.value = e, this.options = n;
  }
  var r = i.prototype;
  return r.toString = function(e) {
    if (Array.isArray(this.value)) {
      for (var n = "", s = 0; s < this.value.length; s++)
        n += this.key + " " + this.value[s] + ";", this.value[s + 1] && (n += `
`);
      return n;
    }
    return this.key + " " + this.value + ";";
  }, i;
}(), Go = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, Uo = {
  onCreateRule: function(r, t, e) {
    return r in Go ? new Ho(r, t, e) : null;
  }
}, ur = [ko, _o, Fo, Bo, zo, Vo, Uo], Jo = {
  process: !0
}, lr = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, ae = /* @__PURE__ */ function() {
  function i(t) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = t, this.classes = t.classes, this.keyframes = t.keyframes;
  }
  var r = i.prototype;
  return r.add = function(e, n, s) {
    var c = this.options, u = c.parent, f = c.sheet, p = c.jss, g = c.Renderer, v = c.generateId, k = c.scoped, T = O({
      classes: this.classes,
      parent: u,
      sheet: f,
      jss: p,
      Renderer: g,
      generateId: v,
      scoped: k,
      name: e,
      keyframes: this.keyframes,
      selector: void 0
    }, s), w = e;
    e in this.raw && (w = e + "-d" + this.counter++), this.raw[w] = n, w in this.classes && (T.selector = "." + Ae(this.classes[w]));
    var _ = rt(w, n, T);
    if (!_)
      return null;
    this.register(_);
    var W = T.index === void 0 ? this.index.length : T.index;
    return this.index.splice(W, 0, _), _;
  }, r.replace = function(e, n, s) {
    var c = this.get(e), u = this.index.indexOf(c);
    c && this.remove(c);
    var f = s;
    return u !== -1 && (f = O({}, s, {
      index: u
    })), this.add(e, n, f);
  }, r.get = function(e) {
    return this.map[e];
  }, r.remove = function(e) {
    this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1);
  }, r.indexOf = function(e) {
    return this.index.indexOf(e);
  }, r.process = function() {
    var e = this.options.jss.plugins;
    this.index.slice(0).forEach(e.onProcessRule, e);
  }, r.register = function(e) {
    this.map[e.key] = e, e instanceof Re ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof Se && this.keyframes && (this.keyframes[e.name] = e.id);
  }, r.unregister = function(e) {
    delete this.map[e.key], e instanceof Re ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof Se && delete this.keyframes[e.name];
  }, r.update = function() {
    var e, n, s;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (e = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], s = arguments.length <= 2 ? void 0 : arguments[2]) : (n = arguments.length <= 0 ? void 0 : arguments[0], s = arguments.length <= 1 ? void 0 : arguments[1], e = null), e)
      this.updateOne(this.get(e), n, s);
    else
      for (var c = 0; c < this.index.length; c++)
        this.updateOne(this.index[c], n, s);
  }, r.updateOne = function(e, n, s) {
    s === void 0 && (s = Jo);
    var c = this.options, u = c.jss.plugins, f = c.sheet;
    if (e.rules instanceof i) {
      e.rules.update(n, s);
      return;
    }
    var p = e.style;
    if (u.onUpdate(n, e, f, s), s.process && p && p !== e.style) {
      u.onProcessStyle(e.style, e, f);
      for (var g in e.style) {
        var v = e.style[g], k = p[g];
        v !== k && e.prop(g, v, lr);
      }
      for (var T in p) {
        var w = e.style[T], _ = p[T];
        w == null && w !== _ && e.prop(T, null, lr);
      }
    }
  }, r.toString = function(e) {
    for (var n = "", s = this.options.sheet, c = s ? s.options.link : !1, u = V(e), f = u.linebreak, p = 0; p < this.index.length; p++) {
      var g = this.index[p], v = g.toString(e);
      !v && !c || (n && (n += f), n += v);
    }
    return n;
  }, i;
}(), nt = /* @__PURE__ */ function() {
  function i(t, e) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = O({}, e, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), e.Renderer && (this.renderer = new e.Renderer(this)), this.rules = new ae(this.options);
    for (var n in t)
      this.rules.add(n, t[n]);
    this.rules.process();
  }
  var r = i.prototype;
  return r.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, r.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, r.addRule = function(e, n, s) {
    var c = this.queue;
    this.attached && !c && (this.queue = []);
    var u = this.rules.add(e, n, s);
    return u ? (this.options.jss.plugins.onProcessRule(u), this.attached ? (this.deployed && (c ? c.push(u) : (this.insertRule(u), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), u) : (this.deployed = !1, u)) : null;
  }, r.replaceRule = function(e, n, s) {
    var c = this.rules.get(e);
    if (!c)
      return this.addRule(e, n, s);
    var u = this.rules.replace(e, n, s);
    return u && this.options.jss.plugins.onProcessRule(u), this.attached ? (this.deployed && this.renderer && (u ? c.renderable && this.renderer.replaceRule(c.renderable, u) : this.renderer.deleteRule(c)), u) : (this.deployed = !1, u);
  }, r.insertRule = function(e) {
    this.renderer && this.renderer.insertRule(e);
  }, r.addRules = function(e, n) {
    var s = [];
    for (var c in e) {
      var u = this.addRule(c, e[c], n);
      u && s.push(u);
    }
    return s;
  }, r.getRule = function(e) {
    return this.rules.get(e);
  }, r.deleteRule = function(e) {
    var n = typeof e == "object" ? e : this.rules.get(e);
    return !n || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !n.renderable ? !1 : (this.rules.remove(n), this.attached && n.renderable && this.renderer ? this.renderer.deleteRule(n.renderable) : !0);
  }, r.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, r.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, r.update = function() {
    var e;
    return (e = this.rules).update.apply(e, arguments), this;
  }, r.updateOne = function(e, n, s) {
    return this.rules.updateOne(e, n, s), this;
  }, r.toString = function(e) {
    return this.rules.toString(e);
  }, i;
}(), Yo = /* @__PURE__ */ function() {
  function i() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var r = i.prototype;
  return r.onCreateRule = function(e, n, s) {
    for (var c = 0; c < this.registry.onCreateRule.length; c++) {
      var u = this.registry.onCreateRule[c](e, n, s);
      if (u)
        return u;
    }
    return null;
  }, r.onProcessRule = function(e) {
    if (!e.isProcessed) {
      for (var n = e.options.sheet, s = 0; s < this.registry.onProcessRule.length; s++)
        this.registry.onProcessRule[s](e, n);
      e.style && this.onProcessStyle(e.style, e, n), e.isProcessed = !0;
    }
  }, r.onProcessStyle = function(e, n, s) {
    for (var c = 0; c < this.registry.onProcessStyle.length; c++)
      n.style = this.registry.onProcessStyle[c](n.style, n, s);
  }, r.onProcessSheet = function(e) {
    for (var n = 0; n < this.registry.onProcessSheet.length; n++)
      this.registry.onProcessSheet[n](e);
  }, r.onUpdate = function(e, n, s, c) {
    for (var u = 0; u < this.registry.onUpdate.length; u++)
      this.registry.onUpdate[u](e, n, s, c);
  }, r.onChangeValue = function(e, n, s) {
    for (var c = e, u = 0; u < this.registry.onChangeValue.length; u++)
      c = this.registry.onChangeValue[u](c, n, s);
    return c;
  }, r.use = function(e, n) {
    n === void 0 && (n = {
      queue: "external"
    });
    var s = this.plugins[n.queue];
    s.indexOf(e) === -1 && (s.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(c, u) {
      for (var f in u)
        f in c ? c[f].push(u[f]) : process.env.NODE_ENV !== "production" && E(!1, '[JSS] Unknown hook "' + f + '".');
      return c;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, i;
}(), qo = /* @__PURE__ */ function() {
  function i() {
    this.registry = [];
  }
  var r = i.prototype;
  return r.add = function(e) {
    var n = this.registry, s = e.options.index;
    if (n.indexOf(e) === -1) {
      if (n.length === 0 || s >= this.index) {
        n.push(e);
        return;
      }
      for (var c = 0; c < n.length; c++)
        if (n[c].options.index > s) {
          n.splice(c, 0, e);
          return;
        }
    }
  }, r.reset = function() {
    this.registry = [];
  }, r.remove = function(e) {
    var n = this.registry.indexOf(e);
    this.registry.splice(n, 1);
  }, r.toString = function(e) {
    for (var n = e === void 0 ? {} : e, s = n.attached, c = Oo(n, ["attached"]), u = V(c), f = u.linebreak, p = "", g = 0; g < this.registry.length; g++) {
      var v = this.registry[g];
      s != null && v.attached !== s || (p && (p += f), p += v.toString(c));
    }
    return p;
  }, Qr(i, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), i;
}(), K = new qo(), xe = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Ce = "2f1acc6c3a606b082e5eef5e54414ffb";
xe[Ce] == null && (xe[Ce] = 0);
var dr = xe[Ce]++, Ko = 1e10, fr = function(r) {
  r === void 0 && (r = {});
  var t = 0, e = function(s, c) {
    t += 1, t > Ko && process.env.NODE_ENV !== "production" && E(!1, "[JSS] You might have a memory leak. Rule counter is at " + t + ".");
    var u = "", f = "";
    return c && (c.options.classNamePrefix && (f = c.options.classNamePrefix), c.options.jss.id != null && (u = String(c.options.jss.id))), r.minify ? "" + (f || "c") + dr + u + t : f + s.key + "-" + dr + (u ? "-" + u : "") + "-" + t;
  };
  return e;
}, it = function(r) {
  var t;
  return function() {
    return t || (t = r()), t;
  };
}, Xo = function(r, t) {
  try {
    return r.attributeStyleMap ? r.attributeStyleMap.get(t) : r.style.getPropertyValue(t);
  } catch {
    return "";
  }
}, Zo = function(r, t, e) {
  try {
    var n = e;
    if (Array.isArray(e) && (n = q(e)), r.attributeStyleMap)
      r.attributeStyleMap.set(t, n);
    else {
      var s = n ? n.indexOf("!important") : -1, c = s > -1 ? n.substr(0, s - 1) : n;
      r.style.setProperty(t, c, s > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, Qo = function(r, t) {
  try {
    r.attributeStyleMap ? r.attributeStyleMap.delete(t) : r.style.removeProperty(t);
  } catch (e) {
    process.env.NODE_ENV !== "production" && E(!1, '[JSS] DOMException "' + e.message + '" was thrown. Tried to remove property "' + t + '".');
  }
}, ea = function(r, t) {
  return r.selectorText = t, r.selectorText === t;
}, ot = it(function() {
  return document.querySelector("head");
});
function ra(i, r) {
  for (var t = 0; t < i.length; t++) {
    var e = i[t];
    if (e.attached && e.options.index > r.index && e.options.insertionPoint === r.insertionPoint)
      return e;
  }
  return null;
}
function ta(i, r) {
  for (var t = i.length - 1; t >= 0; t--) {
    var e = i[t];
    if (e.attached && e.options.insertionPoint === r.insertionPoint)
      return e;
  }
  return null;
}
function na(i) {
  for (var r = ot(), t = 0; t < r.childNodes.length; t++) {
    var e = r.childNodes[t];
    if (e.nodeType === 8 && e.nodeValue.trim() === i)
      return e;
  }
  return null;
}
function ia(i) {
  var r = K.registry;
  if (r.length > 0) {
    var t = ra(r, i);
    if (t && t.renderer)
      return {
        parent: t.renderer.element.parentNode,
        node: t.renderer.element
      };
    if (t = ta(r, i), t && t.renderer)
      return {
        parent: t.renderer.element.parentNode,
        node: t.renderer.element.nextSibling
      };
  }
  var e = i.insertionPoint;
  if (e && typeof e == "string") {
    var n = na(e);
    if (n)
      return {
        parent: n.parentNode,
        node: n.nextSibling
      };
    process.env.NODE_ENV !== "production" && E(!1, '[JSS] Insertion point "' + e + '" not found.');
  }
  return !1;
}
function oa(i, r) {
  var t = r.insertionPoint, e = ia(r);
  if (e !== !1 && e.parent) {
    e.parent.insertBefore(i, e.node);
    return;
  }
  if (t && typeof t.nodeType == "number") {
    var n = t, s = n.parentNode;
    s ? s.insertBefore(i, n.nextSibling) : process.env.NODE_ENV !== "production" && E(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  ot().appendChild(i);
}
var aa = it(function() {
  var i = document.querySelector('meta[property="csp-nonce"]');
  return i ? i.getAttribute("content") : null;
}), hr = function(r, t, e) {
  try {
    "insertRule" in r ? r.insertRule(t, e) : "appendRule" in r && r.appendRule(t);
  } catch (n) {
    return process.env.NODE_ENV !== "production" && E(!1, "[JSS] " + n.message), !1;
  }
  return r.cssRules[e];
}, pr = function(r, t) {
  var e = r.cssRules.length;
  return t === void 0 || t > e ? e : t;
}, sa = function() {
  var r = document.createElement("style");
  return r.textContent = `
`, r;
}, ca = /* @__PURE__ */ function() {
  function i(t) {
    this.getPropertyValue = Xo, this.setProperty = Zo, this.removeProperty = Qo, this.setSelector = ea, this.hasInsertedRules = !1, this.cssRules = [], t && K.add(t), this.sheet = t;
    var e = this.sheet ? this.sheet.options : {}, n = e.media, s = e.meta, c = e.element;
    this.element = c || sa(), this.element.setAttribute("data-jss", ""), n && this.element.setAttribute("media", n), s && this.element.setAttribute("data-meta", s);
    var u = aa();
    u && this.element.setAttribute("nonce", u);
  }
  var r = i.prototype;
  return r.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      oa(this.element, this.sheet.options);
      var e = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy());
    }
  }, r.detach = function() {
    if (this.sheet) {
      var e = this.element.parentNode;
      e && e.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, r.deploy = function() {
    var e = this.sheet;
    if (e) {
      if (e.options.link) {
        this.insertRules(e.rules);
        return;
      }
      this.element.textContent = `
` + e.toString() + `
`;
    }
  }, r.insertRules = function(e, n) {
    for (var s = 0; s < e.index.length; s++)
      this.insertRule(e.index[s], s, n);
  }, r.insertRule = function(e, n, s) {
    if (s === void 0 && (s = this.element.sheet), e.rules) {
      var c = e, u = s;
      if (e.type === "conditional" || e.type === "keyframes") {
        var f = pr(s, n);
        if (u = hr(s, c.toString({
          children: !1
        }), f), u === !1)
          return !1;
        this.refCssRule(e, f, u);
      }
      return this.insertRules(c.rules, u), u;
    }
    var p = e.toString();
    if (!p)
      return !1;
    var g = pr(s, n), v = hr(s, p, g);
    return v === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(e, g, v), v);
  }, r.refCssRule = function(e, n, s) {
    e.renderable = s, e.options.parent instanceof nt && this.cssRules.splice(n, 0, s);
  }, r.deleteRule = function(e) {
    var n = this.element.sheet, s = this.indexOf(e);
    return s === -1 ? !1 : (n.deleteRule(s), this.cssRules.splice(s, 1), !0);
  }, r.indexOf = function(e) {
    return this.cssRules.indexOf(e);
  }, r.replaceRule = function(e, n) {
    var s = this.indexOf(e);
    return s === -1 ? !1 : (this.element.sheet.deleteRule(s), this.cssRules.splice(s, 1), this.insertRule(n, s));
  }, r.getRules = function() {
    return this.element.sheet.cssRules;
  }, i;
}(), ua = 0, la = /* @__PURE__ */ function() {
  function i(t) {
    this.id = ua++, this.version = "10.10.0", this.plugins = new Yo(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: fr,
      Renderer: So ? ca : null,
      plugins: []
    }, this.generateId = fr({
      minify: !1
    });
    for (var e = 0; e < ur.length; e++)
      this.plugins.use(ur[e], {
        queue: "internal"
      });
    this.setup(t);
  }
  var r = i.prototype;
  return r.setup = function(e) {
    return e === void 0 && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = O({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), e.insertionPoint != null && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this;
  }, r.createStyleSheet = function(e, n) {
    n === void 0 && (n = {});
    var s = n, c = s.index;
    typeof c != "number" && (c = K.index === 0 ? 0 : K.index + 1);
    var u = new nt(e, O({}, n, {
      jss: this,
      generateId: n.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: c
    }));
    return this.plugins.onProcessSheet(u), u;
  }, r.removeStyleSheet = function(e) {
    return e.detach(), K.remove(e), this;
  }, r.createRule = function(e, n, s) {
    if (n === void 0 && (n = {}), s === void 0 && (s = {}), typeof e == "object")
      return this.createRule(void 0, e, n);
    var c = O({}, s, {
      name: e,
      jss: this,
      Renderer: this.options.Renderer
    });
    c.generateId || (c.generateId = this.generateId), c.classes || (c.classes = {}), c.keyframes || (c.keyframes = {});
    var u = rt(e, n, c);
    return u && this.plugins.onProcessRule(u), u;
  }, r.use = function() {
    for (var e = this, n = arguments.length, s = new Array(n), c = 0; c < n; c++)
      s[c] = arguments[c];
    return s.forEach(function(u) {
      e.plugins.use(u);
    }), this;
  }, i;
}(), at = function(r) {
  return new la(r);
};
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
at();
function Oe(i, r) {
  if (!r)
    return !0;
  if (Array.isArray(r)) {
    for (var t = 0; t < r.length; t++) {
      var e = Oe(i, r[t]);
      if (!e)
        return !1;
    }
    return !0;
  }
  if (r.indexOf(" ") > -1)
    return Oe(i, r.split(" "));
  var n = i.options.parent;
  if (r[0] === "$") {
    var s = n.getRule(r.substr(1));
    return s ? s === i ? (process.env.NODE_ENV !== "production" && E(!1, `[JSS] Cyclic composition detected. 
` + i.toString()), !1) : (n.classes[i.key] += " " + n.classes[s.key], !0) : (process.env.NODE_ENV !== "production" && E(!1, `[JSS] Referenced rule is not defined. 
` + i.toString()), !1);
  }
  return n.classes[i.key] += " " + r, !0;
}
function da() {
  function i(r, t) {
    return "composes" in r && (Oe(t, r.composes), delete r.composes), r;
  }
  return {
    onProcessStyle: i
  };
}
var ie = function(r) {
  return r && typeof r == "object" && !Array.isArray(r);
}, ye = "extendCurrValue" + Date.now();
function fa(i, r, t, e) {
  var n = typeof i.extend;
  if (n === "string") {
    if (!t)
      return;
    var s = t.getRule(i.extend);
    if (!s)
      return;
    if (s === r) {
      process.env.NODE_ENV !== "production" && E(!1, `[JSS] A rule tries to extend itself 
` + r.toString());
      return;
    }
    var c = s.options.parent;
    if (c) {
      var u = c.rules.raw[i.extend];
      $(u, r, t, e);
    }
    return;
  }
  if (Array.isArray(i.extend)) {
    for (var f = 0; f < i.extend.length; f++) {
      var p = i.extend[f], g = typeof p == "string" ? O({}, i, {
        extend: p
      }) : i.extend[f];
      $(g, r, t, e);
    }
    return;
  }
  for (var v in i.extend) {
    if (v === "extend") {
      $(i.extend.extend, r, t, e);
      continue;
    }
    if (ie(i.extend[v])) {
      v in e || (e[v] = {}), $(i.extend[v], r, t, e[v]);
      continue;
    }
    e[v] = i.extend[v];
  }
}
function ha(i, r, t, e) {
  for (var n in i)
    if (n !== "extend") {
      if (ie(e[n]) && ie(i[n])) {
        $(i[n], r, t, e[n]);
        continue;
      }
      if (ie(i[n])) {
        e[n] = $(i[n], r, t);
        continue;
      }
      e[n] = i[n];
    }
}
function $(i, r, t, e) {
  return e === void 0 && (e = {}), fa(i, r, t, e), ha(i, r, t, e), e;
}
function pa() {
  function i(t, e, n) {
    return "extend" in t ? $(t, e, n) : t;
  }
  function r(t, e, n) {
    if (e !== "extend")
      return t;
    if (t == null || t === !1) {
      for (var s in n[ye])
        n.prop(s, null);
      return n[ye] = null, null;
    }
    if (typeof t == "object") {
      for (var c in t)
        n.prop(c, t[c]);
      n[ye] = t;
    }
    return null;
  }
  return {
    onProcessStyle: i,
    onChangeValue: r
  };
}
var j = "@global", Te = "@global ", ga = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "global", this.at = j, this.isProcessed = !1, this.key = t, this.options = n, this.rules = new ae(O({}, n, {
      parent: this
    }));
    for (var s in e)
      this.rules.add(s, e[s]);
    this.rules.process();
  }
  var r = i.prototype;
  return r.getRule = function(e) {
    return this.rules.get(e);
  }, r.addRule = function(e, n, s) {
    var c = this.rules.add(e, n, s);
    return c && this.options.jss.plugins.onProcessRule(c), c;
  }, r.replaceRule = function(e, n, s) {
    var c = this.rules.replace(e, n, s);
    return c && this.options.jss.plugins.onProcessRule(c), c;
  }, r.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, r.toString = function(e) {
    return this.rules.toString(e);
  }, i;
}(), va = /* @__PURE__ */ function() {
  function i(t, e, n) {
    this.type = "global", this.at = j, this.isProcessed = !1, this.key = t, this.options = n;
    var s = t.substr(Te.length);
    this.rule = n.jss.createRule(s, e, O({}, n, {
      parent: this
    }));
  }
  var r = i.prototype;
  return r.toString = function(e) {
    return this.rule ? this.rule.toString(e) : "";
  }, i;
}(), ya = /\s*,\s*/g;
function st(i, r) {
  for (var t = i.split(ya), e = "", n = 0; n < t.length; n++)
    e += r + " " + t[n].trim(), t[n + 1] && (e += ", ");
  return e;
}
function ma(i, r) {
  var t = i.options, e = i.style, n = e ? e[j] : null;
  if (n) {
    for (var s in n)
      r.addRule(s, n[s], O({}, t, {
        selector: st(s, i.selector)
      }));
    delete e[j];
  }
}
function ba(i, r) {
  var t = i.options, e = i.style;
  for (var n in e)
    if (!(n[0] !== "@" || n.substr(0, j.length) !== j)) {
      var s = st(n.substr(j.length), i.selector);
      r.addRule(s, e[n], O({}, t, {
        selector: s
      })), delete e[n];
    }
}
function Ra() {
  function i(t, e, n) {
    if (!t)
      return null;
    if (t === j)
      return new ga(t, e, n);
    if (t[0] === "@" && t.substr(0, Te.length) === Te)
      return new va(t, e, n);
    var s = n.parent;
    return s && (s.type === "global" || s.options.parent && s.options.parent.type === "global") && (n.scoped = !1), !n.selector && n.scoped === !1 && (n.selector = t), null;
  }
  function r(t, e) {
    t.type !== "style" || !e || (ma(t, e), ba(t, e));
  }
  return {
    onCreateRule: i,
    onProcessRule: r
  };
}
const gl = at({
  plugins: [pa(), da(), Ra(), ...Nt().plugins]
}), oe = {
  primary: {
    main: a.primaryMain,
    light: a.primaryLight,
    dark: a.primaryDark,
    contrastText: a.primaryContrast
  },
  secondary: {
    main: a.secondaryMain,
    light: a.secondaryLight,
    dark: a.secondaryDark,
    contrastText: a.secondaryContrast
  },
  error: {
    main: a.errorMain,
    light: a.errorLight,
    dark: a.errorDark,
    contrastText: a.errorContrast
  },
  warning: {
    main: a.warningMain,
    light: a.warningLight,
    dark: a.warningDark,
    contrastText: a.warningContrast
  },
  success: {
    main: a.successMain,
    light: a.successLight,
    dark: a.successDark,
    contrastText: a.successContrast
  },
  text: {
    primary: a.textPrimary,
    secondary: a.textSecondary,
    disabled: a.textDisabled,
    hint: a.textHint
  },
  neutral: {
    main: a.neutralBase,
    light: a.neutralLight,
    dark: a.neutralDark,
    contrastText: a.neutralLighter
  },
  // deprecated but still in use
  grey: {
    50: a.grey50,
    100: a.grey100,
    200: a.grey200,
    300: a.grey300,
    400: a.grey400,
    500: a.grey500,
    600: a.grey600,
    700: a.grey700,
    800: a.grey800,
    900: a.grey900,
    A100: a.greyA100,
    A200: a.greyA200,
    A400: a.greyA400,
    A700: a.greyA700
  },
  gray: {
    50: a.gray50,
    100: a.gray100,
    200: a.gray200,
    300: a.gray300,
    400: a.gray400,
    500: a.gray500,
    600: a.gray600,
    700: a.gray700,
    800: a.gray800,
    900: a.gray900,
    1e3: a.gray1000,
    1200: a.gray1200,
    1400: a.gray1400,
    1600: a.gray1600,
    1800: a.gray1800
  },
  green: {
    50: a.green50,
    100: a.green100,
    200: a.green200,
    300: a.green300,
    400: a.green400,
    500: a.green500,
    600: a.green600,
    700: a.green700,
    800: a.green800,
    900: a.green900,
    1e3: a.green1000,
    1200: a.green1200,
    1400: a.green1400,
    1600: a.green1600
  },
  magenta: {
    50: a.magenta50,
    100: a.magenta100,
    200: a.magenta200,
    300: a.magenta300,
    400: a.magenta400,
    500: a.magenta500,
    600: a.magenta600,
    700: a.magenta700,
    800: a.magenta800,
    900: a.magenta900,
    1e3: a.magenta1000,
    1200: a.magenta1200,
    1400: a.magenta1400,
    1600: a.magenta1600
  },
  orange: {
    50: a.orange50,
    100: a.orange100,
    200: a.orange200,
    300: a.orange300,
    400: a.orange400,
    500: a.orange500,
    600: a.orange600,
    700: a.orange700,
    800: a.orange800,
    900: a.orange900,
    1e3: a.orange1000,
    1200: a.orange1200,
    1400: a.orange1400,
    1600: a.orange1600
  },
  red: {
    50: a.red50,
    100: a.red100,
    200: a.red200,
    300: a.red300,
    400: a.red400,
    500: a.red500,
    600: a.red600,
    700: a.red700,
    800: a.red800,
    900: a.red900,
    1e3: a.red1000,
    1200: a.red1200,
    1400: a.red1400,
    1600: a.red1600
  },
  violet: {
    50: a.violet50,
    100: a.violet100,
    200: a.violet200,
    300: a.violet300,
    400: a.violet400,
    500: a.violet500,
    600: a.violet600,
    700: a.violet700,
    800: a.violet800,
    900: a.violet900,
    1e3: a.violet1000,
    1200: a.violet1200,
    1400: a.violet1400,
    1600: a.violet1600
  },
  blue: {
    50: a.blue50,
    100: a.blue100,
    200: a.blue200,
    300: a.blue300,
    400: a.blue400,
    500: a.blue500,
    600: a.blue600,
    700: a.blue700,
    800: a.blue800,
    900: a.blue900,
    1e3: a.blue1000,
    1200: a.blue1200,
    1400: a.blue1400,
    1600: a.blue1600
  },
  cyan: {
    50: a.cyan50,
    100: a.cyan100,
    200: a.cyan200,
    300: a.cyan300,
    400: a.cyan400,
    500: a.cyan500,
    600: a.cyan600,
    700: a.cyan700,
    800: a.cyan800,
    900: a.cyan900,
    1e3: a.cyan1000,
    1200: a.cyan1200,
    1400: a.cyan1400,
    1600: a.cyan1600
  }
}, Sa = {
  root: {
    border: 0,
    boxShadow: "none",
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: 0
    }
  }
}, Pa = {
  TransitionProps: {
    timeout: 0
  }
}, xa = {}, gr = {}, Ca = {
  root: {
    padding: 0
  }
};
var Me = { exports: {} }, J = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vr;
function Oa() {
  if (vr)
    return J;
  vr = 1;
  var i = xr, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), e = Object.prototype.hasOwnProperty, n = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(u, f, p) {
    var g, v = {}, k = null, T = null;
    p !== void 0 && (k = "" + p), f.key !== void 0 && (k = "" + f.key), f.ref !== void 0 && (T = f.ref);
    for (g in f)
      e.call(f, g) && !s.hasOwnProperty(g) && (v[g] = f[g]);
    if (u && u.defaultProps)
      for (g in f = u.defaultProps, f)
        v[g] === void 0 && (v[g] = f[g]);
    return { $$typeof: r, type: u, key: k, ref: T, props: v, _owner: n.current };
  }
  return J.Fragment = t, J.jsx = c, J.jsxs = c, J;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yr;
function Ta() {
  return yr || (yr = 1, process.env.NODE_ENV !== "production" && function() {
    var i = xr, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), e = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), w = Symbol.iterator, _ = "@@iterator";
    function W(o) {
      if (o === null || typeof o != "object")
        return null;
      var l = w && o[w] || o[_];
      return typeof l == "function" ? l : null;
    }
    var I = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(o) {
      {
        for (var l = arguments.length, d = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
          d[h - 1] = arguments[h];
        ut("error", o, d);
      }
    }
    function ut(o, l, d) {
      {
        var h = I.ReactDebugCurrentFrame, R = h.getStackAddendum();
        R !== "" && (l += "%s", d = d.concat([R]));
        var S = d.map(function(b) {
          return String(b);
        });
        S.unshift("Warning: " + l), Function.prototype.apply.call(console[o], console, S);
      }
    }
    var lt = !1, dt = !1, ft = !1, ht = !1, pt = !1, Ie;
    Ie = Symbol.for("react.module.reference");
    function gt(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === e || o === s || pt || o === n || o === p || o === g || ht || o === T || lt || dt || ft || typeof o == "object" && o !== null && (o.$$typeof === k || o.$$typeof === v || o.$$typeof === c || o.$$typeof === u || o.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === Ie || o.getModuleId !== void 0));
    }
    function vt(o, l, d) {
      var h = o.displayName;
      if (h)
        return h;
      var R = l.displayName || l.name || "";
      return R !== "" ? d + "(" + R + ")" : d;
    }
    function De(o) {
      return o.displayName || "Context";
    }
    function D(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case e:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case n:
          return "StrictMode";
        case p:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case u:
            var l = o;
            return De(l) + ".Consumer";
          case c:
            var d = o;
            return De(d._context) + ".Provider";
          case f:
            return vt(o, o.render, "ForwardRef");
          case v:
            var h = o.displayName || null;
            return h !== null ? h : D(o.type) || "Memo";
          case k: {
            var R = o, S = R._payload, b = R._init;
            try {
              return D(b(S));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, H = 0, Le, Fe, je, Be, $e, We, ze;
    function Ne() {
    }
    Ne.__reactDisabledLog = !0;
    function yt() {
      {
        if (H === 0) {
          Le = console.log, Fe = console.info, je = console.warn, Be = console.error, $e = console.group, We = console.groupCollapsed, ze = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: Ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        H++;
      }
    }
    function mt() {
      {
        if (H--, H === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, o, {
              value: Le
            }),
            info: B({}, o, {
              value: Fe
            }),
            warn: B({}, o, {
              value: je
            }),
            error: B({}, o, {
              value: Be
            }),
            group: B({}, o, {
              value: $e
            }),
            groupCollapsed: B({}, o, {
              value: We
            }),
            groupEnd: B({}, o, {
              value: ze
            })
          });
        }
        H < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = I.ReactCurrentDispatcher, ce;
    function Q(o, l, d) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (R) {
            var h = R.stack.trim().match(/\n( *(at )?)/);
            ce = h && h[1] || "";
          }
        return `
` + ce + o;
      }
    }
    var ue = !1, ee;
    {
      var bt = typeof WeakMap == "function" ? WeakMap : Map;
      ee = new bt();
    }
    function Ve(o, l) {
      if (!o || ue)
        return "";
      {
        var d = ee.get(o);
        if (d !== void 0)
          return d;
      }
      var h;
      ue = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var S;
      S = se.current, se.current = null, yt();
      try {
        if (l) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (L) {
              h = L;
            }
            Reflect.construct(o, [], b);
          } else {
            try {
              b.call();
            } catch (L) {
              h = L;
            }
            o.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (L) {
            h = L;
          }
          o();
        }
      } catch (L) {
        if (L && h && typeof L.stack == "string") {
          for (var y = L.stack.split(`
`), M = h.stack.split(`
`), P = y.length - 1, x = M.length - 1; P >= 1 && x >= 0 && y[P] !== M[x]; )
            x--;
          for (; P >= 1 && x >= 0; P--, x--)
            if (y[P] !== M[x]) {
              if (P !== 1 || x !== 1)
                do
                  if (P--, x--, x < 0 || y[P] !== M[x]) {
                    var A = `
` + y[P].replace(" at new ", " at ");
                    return o.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", o.displayName)), typeof o == "function" && ee.set(o, A), A;
                  }
                while (P >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ue = !1, se.current = S, mt(), Error.prepareStackTrace = R;
      }
      var N = o ? o.displayName || o.name : "", tr = N ? Q(N) : "";
      return typeof o == "function" && ee.set(o, tr), tr;
    }
    function Rt(o, l, d) {
      return Ve(o, !1);
    }
    function St(o) {
      var l = o.prototype;
      return !!(l && l.isReactComponent);
    }
    function re(o, l, d) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return Ve(o, St(o));
      if (typeof o == "string")
        return Q(o);
      switch (o) {
        case p:
          return Q("Suspense");
        case g:
          return Q("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case f:
            return Rt(o.render);
          case v:
            return re(o.type, l, d);
          case k: {
            var h = o, R = h._payload, S = h._init;
            try {
              return re(S(R), l, d);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, He = {}, Ge = I.ReactDebugCurrentFrame;
    function ne(o) {
      if (o) {
        var l = o._owner, d = re(o.type, o._source, l ? l.type : null);
        Ge.setExtraStackFrame(d);
      } else
        Ge.setExtraStackFrame(null);
    }
    function Pt(o, l, d, h, R) {
      {
        var S = Function.call.bind(te);
        for (var b in o)
          if (S(o, b)) {
            var y = void 0;
            try {
              if (typeof o[b] != "function") {
                var M = Error((h || "React class") + ": " + d + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw M.name = "Invariant Violation", M;
              }
              y = o[b](l, b, h, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (P) {
              y = P;
            }
            y && !(y instanceof Error) && (ne(R), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", d, b, typeof y), ne(null)), y instanceof Error && !(y.message in He) && (He[y.message] = !0, ne(R), C("Failed %s type: %s", d, y.message), ne(null));
          }
      }
    }
    var xt = Array.isArray;
    function le(o) {
      return xt(o);
    }
    function Ct(o) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, d = l && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return d;
      }
    }
    function Ot(o) {
      try {
        return Ue(o), !1;
      } catch {
        return !0;
      }
    }
    function Ue(o) {
      return "" + o;
    }
    function Je(o) {
      if (Ot(o))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ct(o)), Ue(o);
    }
    var G = I.ReactCurrentOwner, Tt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ye, qe, de;
    de = {};
    function Mt(o) {
      if (te.call(o, "ref")) {
        var l = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function kt(o) {
      if (te.call(o, "key")) {
        var l = Object.getOwnPropertyDescriptor(o, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function wt(o, l) {
      if (typeof o.ref == "string" && G.current && l && G.current.stateNode !== l) {
        var d = D(G.current.type);
        de[d] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(G.current.type), o.ref), de[d] = !0);
      }
    }
    function Et(o, l) {
      {
        var d = function() {
          Ye || (Ye = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        d.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: d,
          configurable: !0
        });
      }
    }
    function At(o, l) {
      {
        var d = function() {
          qe || (qe = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        d.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: d,
          configurable: !0
        });
      }
    }
    var _t = function(o, l, d, h, R, S, b) {
      var y = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: o,
        key: l,
        ref: d,
        props: b,
        // Record the component responsible for creating this element.
        _owner: S
      };
      return y._store = {}, Object.defineProperty(y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(y, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(y, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(y.props), Object.freeze(y)), y;
    };
    function It(o, l, d, h, R) {
      {
        var S, b = {}, y = null, M = null;
        d !== void 0 && (Je(d), y = "" + d), kt(l) && (Je(l.key), y = "" + l.key), Mt(l) && (M = l.ref, wt(l, R));
        for (S in l)
          te.call(l, S) && !Tt.hasOwnProperty(S) && (b[S] = l[S]);
        if (o && o.defaultProps) {
          var P = o.defaultProps;
          for (S in P)
            b[S] === void 0 && (b[S] = P[S]);
        }
        if (y || M) {
          var x = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          y && Et(b, x), M && At(b, x);
        }
        return _t(o, y, M, R, h, G.current, b);
      }
    }
    var fe = I.ReactCurrentOwner, Ke = I.ReactDebugCurrentFrame;
    function z(o) {
      if (o) {
        var l = o._owner, d = re(o.type, o._source, l ? l.type : null);
        Ke.setExtraStackFrame(d);
      } else
        Ke.setExtraStackFrame(null);
    }
    var he;
    he = !1;
    function pe(o) {
      return typeof o == "object" && o !== null && o.$$typeof === r;
    }
    function Xe() {
      {
        if (fe.current) {
          var o = D(fe.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function Dt(o) {
      {
        if (o !== void 0) {
          var l = o.fileName.replace(/^.*[\\\/]/, ""), d = o.lineNumber;
          return `

Check your code at ` + l + ":" + d + ".";
        }
        return "";
      }
    }
    var Ze = {};
    function Lt(o) {
      {
        var l = Xe();
        if (!l) {
          var d = typeof o == "string" ? o : o.displayName || o.name;
          d && (l = `

Check the top-level render call using <` + d + ">.");
        }
        return l;
      }
    }
    function Qe(o, l) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var d = Lt(l);
        if (Ze[d])
          return;
        Ze[d] = !0;
        var h = "";
        o && o._owner && o._owner !== fe.current && (h = " It was passed a child from " + D(o._owner.type) + "."), z(o), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, h), z(null);
      }
    }
    function er(o, l) {
      {
        if (typeof o != "object")
          return;
        if (le(o))
          for (var d = 0; d < o.length; d++) {
            var h = o[d];
            pe(h) && Qe(h, l);
          }
        else if (pe(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var R = W(o);
          if (typeof R == "function" && R !== o.entries)
            for (var S = R.call(o), b; !(b = S.next()).done; )
              pe(b.value) && Qe(b.value, l);
        }
      }
    }
    function Ft(o) {
      {
        var l = o.type;
        if (l == null || typeof l == "string")
          return;
        var d;
        if (typeof l == "function")
          d = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === v))
          d = l.propTypes;
        else
          return;
        if (d) {
          var h = D(l);
          Pt(d, o.props, "prop", h, o);
        } else if (l.PropTypes !== void 0 && !he) {
          he = !0;
          var R = D(l);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function jt(o) {
      {
        for (var l = Object.keys(o.props), d = 0; d < l.length; d++) {
          var h = l[d];
          if (h !== "children" && h !== "key") {
            z(o), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), z(null);
            break;
          }
        }
        o.ref !== null && (z(o), C("Invalid attribute `ref` supplied to `React.Fragment`."), z(null));
      }
    }
    function rr(o, l, d, h, R, S) {
      {
        var b = gt(o);
        if (!b) {
          var y = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var M = Dt(R);
          M ? y += M : y += Xe();
          var P;
          o === null ? P = "null" : le(o) ? P = "array" : o !== void 0 && o.$$typeof === r ? (P = "<" + (D(o.type) || "Unknown") + " />", y = " Did you accidentally export a JSX literal instead of a component?") : P = typeof o, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", P, y);
        }
        var x = It(o, l, d, R, S);
        if (x == null)
          return x;
        if (b) {
          var A = l.children;
          if (A !== void 0)
            if (h)
              if (le(A)) {
                for (var N = 0; N < A.length; N++)
                  er(A[N], o);
                Object.freeze && Object.freeze(A);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              er(A, o);
        }
        return o === e ? jt(x) : Ft(x), x;
      }
    }
    function Bt(o, l, d) {
      return rr(o, l, d, !0);
    }
    function $t(o, l, d) {
      return rr(o, l, d, !1);
    }
    var Wt = $t, zt = Bt;
    Y.Fragment = e, Y.jsx = Wt, Y.jsxs = zt;
  }()), Y;
}
process.env.NODE_ENV === "production" ? Me.exports = Oa() : Me.exports = Ta();
var F = Me.exports;
const m = (i) => `${i * 0.5}rem`, Ma = {
  root: {
    padding: `0 0 ${m(0.5)}`,
    "&$expanded": {
      minHeight: "auto",
      margin: 0
    }
  },
  focusVisible: {},
  disabled: {},
  content: {
    margin: 0,
    "&$expanded": {
      margin: 0
    }
  },
  expandIcon: {
    transition: "none",
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0
  }
}, ka = {
  expandIcon: /* @__PURE__ */ F.jsx(ke, { fontSize: "small" })
}, wa = {}, Ea = {
  closeText: "Close",
  severity: "info",
  variant: "standard",
  iconMapping: {
    error: /* @__PURE__ */ F.jsx(Ht, { fontSize: "small", color: "inherit" }),
    info: /* @__PURE__ */ F.jsx(Gt, { fontSize: "small", color: "inherit" }),
    success: /* @__PURE__ */ F.jsx(Ut, { fontSize: "small", color: "inherit" }),
    warning: /* @__PURE__ */ F.jsx(Jt, { fontSize: "small", color: "inherit" })
  }
}, Aa = {
  root: {
    color: "inherit"
  }
}, _a = {}, Ia = {
  root: {
    boxShadow: "none"
  }
}, Da = {}, _e = {
  low: "0px 2px 4px -1px rgba(0, 34, 63, 0.15), 0px 1px 2px -1px rgba(0, 34, 63, 0.10)",
  medium: "0px 4px 16px -2px rgba(0, 34, 63, 0.15), 0px 2px 4px -1px rgba(0, 34, 63, 0.15)",
  high: "0px 8px 24px -2px rgba(0, 21, 38, 0.30), 0px 2px 16px -2px rgba(0, 34, 63, 0.20)"
}, La = {
  input: {
    "&&&": {
      padding: `${m(1)} 0`
    },
    "&&&:first-child": {
      paddingLeft: 0
    }
  },
  inputRoot: {
    "&&": {
      padding: `0 0 0 ${m(1)}`,
      height: "32px"
    }
  },
  endAdornment: {
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center"
  },
  tag: {
    height: m(3),
    margin: `${m(0.25)} ${m(0.6)}`
  },
  paper: {
    boxShadow: _e.medium
  }
}, Fa = {
  popupIcon: /* @__PURE__ */ F.jsx(ke, { fontSize: "small" })
}, ja = {}, Ba = {}, $a = {}, Wa = {}, mr = {}, za = {}, Na = {}, Va = {
  open: !1
}, Ha = {}, Ga = {}, Ua = {}, Ja = {}, Ya = {}, qa = {}, Ka = {}, ct = {
  borderRadius: 4
}, Xa = {
  root: {
    textTransform: "none",
    padding: `${m(2)} ${m(3)}`,
    borderRadius: ct.borderRadius,
    height: "32px"
  },
  sizeLarge: {
    height: "48px"
  },
  contained: {
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none"
    },
    "&$disabled": {
      color: a.white,
      backgroundColor: a.neutralDark
    }
  },
  containedSizeLarge: {
    padding: `${m(2)} ${m(3)}`
  },
  outlined: {
    borderWidth: "1px",
    borderColor: "inherit",
    "&$disabled": {
      color: a.neutralDark,
      border: `1px solid ${a.neutralDark}`
    }
  },
  outlinedPrimary: {
    border: `1px solid ${a.primaryMain}`
  },
  outlinedSizeLarge: {
    borderWidth: "1.4px",
    padding: `${m(2)} ${m(3)}`,
    "&:hover": {
      borderWidth: "1.4px"
    },
    "&$disabled": {
      borderWidth: "1.4px"
    }
  },
  text: {
    padding: `${m(1)} ${m(3)}`,
    "& .MuiTypography-button": {
      textDecoration: "underline"
    },
    "&$disabled": {
      color: a.neutralDark
    }
  },
  textSizeLarge: {
    padding: `${m(2)} ${m(3)}`
  }
}, Za = {
  color: "primary",
  disableElevation: !0,
  size: "medium",
  variant: "contained"
}, Qa = {
  grouped: {}
}, es = {
  color: "primary",
  variant: "contained",
  orientation: "horizontal",
  disableElevation: !0,
  size: "medium"
}, rs = {
  root: {
    overflow: "visible",
    boxShadow: _e.low,
    borderRadius: "8px"
  }
}, ts = {}, br = {}, ns = {}, is = {}, os = {}, as = {}, ss = {}, cs = {}, us = {}, ls = {
  root: {
    padding: m(1),
    paddingRight: m(0.75),
    color: a.neutralDark
  },
  colorPrimary: {
    "&$disabled": {
      color: a.neutralBase
    },
    "&$indeterminate": {
      color: a.primaryMain
    }
  },
  colorSecondary: {
    "&$indeterminate": {
      color: a.secondaryMain
    }
  }
}, ds = {
  color: "primary",
  size: "small"
}, fs = {
  labelSmall: {
    fontSize: "0.75rem"
  }
}, hs = {
  color: "primary",
  deleteIcon: /* @__PURE__ */ F.jsx(Cr, { fontSize: "small" })
}, ps = {
  labelSmall: {
    fontSize: "0.75rem"
  }
}, gs = {
  color: "primary",
  deleteIcon: /* @__PURE__ */ F.jsx(Cr, { fontSize: "small" })
}, vs = {}, ys = {}, ms = {}, bs = {}, Rs = {}, Ss = {
  variant: "indeterminate"
}, Ps = {}, xs = {
  maxWidth: "xl"
}, Cs = {}, Os = {}, Ts = {}, Ms = {}, ks = {}, ws = {}, Es = {}, As = {}, _s = {}, Is = {}, Ds = {}, Ls = {}, Fs = {}, js = {}, Bs = {}, $s = {}, Ws = {}, zs = {}, Ns = {}, Vs = {}, Hs = {}, Gs = {}, Us = {
  fullWidth: !0,
  maxWidth: "md"
}, Js = {}, Ys = {}, qs = {}, Ks = {}, Xs = {}, Zs = {}, Qs = {}, ec = {}, rc = {}, tc = {
  color: "primary"
}, nc = {}, ic = {}, oc = {}, ac = {}, sc = {}, cc = {}, uc = {}, lc = {}, dc = {}, fc = {}, hc = {
  label: {
    "&$disabled": {
      color: a.neutralBase
    }
  }
}, pc = {}, gc = {}, vc = {}, yc = {
  root: {
    "&$disabled": {
      color: a.neutralBase
    }
  },
  contained: {
    marginLeft: m(0.25),
    marginRight: 0
  }
}, mc = {}, bc = {
  root: {
    color: a.textPrimary,
    fontSize: "0.875rem",
    "&$error": {
      color: a.textPrimary
    },
    "&$focused": {
      color: a.textPrimary
    },
    "&$disabled": {
      color: a.neutralBase
    }
  }
}, Rc = {}, Sc = {}, Pc = {}, xc = {}, Cc = {}, Oc = {}, Tc = {
  color: "inherit"
}, Mc = {
  root: {
    "&.Mui-disabled svg": {
      fill: "currentColor"
    }
  },
  sizeSmall: {
    fontSize: "1rem"
  }
}, kc = {
  color: "inherit"
}, wc = {}, Ec = {}, Ac = {
  input: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.5rem"
  },
  underline: {
    "&$disabled::before": {
      borderBottomStyle: "solid",
      borderBottomColor: a.neutralBase
    }
  }
}, _c = {}, Ic = {
  outlined: {
    transform: "none",
    marginBottom: m(0.75),
    marginLeft: m(0.25),
    fontSize: "0.75rem",
    color: a.textPrimary
  },
  shrink: {
    "&&&": {
      transform: "none"
    }
  },
  formControl: {
    position: "relative",
    top: "auto",
    left: "auto"
  }
}, Dc = {
  color: "primary",
  disableAnimation: !0,
  shrink: !0
}, Lc = {
  root: {},
  underlineAlways: {
    cursor: "pointer"
  }
}, Fc = {
  color: "primary",
  underline: "hover"
}, jc = {}, Bc = {}, $c = {}, Wc = {}, zc = {}, Nc = {}, Vc = {}, Hc = {}, Gc = {}, Uc = {}, Jc = {
  paper: {
    boxShadow: _e.medium
  }
}, Yc = {}, qc = {}, Kc = {}, Xc = {
  root: {
    height: "32px",
    backgroundColor: a.white,
    lineHeight: "1.5rem",
    "&$disabled": {
      backgroundColor: a.neutralLighter,
      color: a.textPrimary
    },
    "&$disabled $notchedOutline": {
      borderColor: a.neutralLight
    },
    "&:hover $notchedOutline": {
      borderColor: a.primaryLight
    },
    "&$focused $notchedOutline": {
      borderWidth: "1px",
      borderColor: a.primaryMain,
      boxShadow: "0px 2px 8px -1px rgba(0, 0, 0, 0.15)"
    },
    "&$error $notchedOutline": {
      borderWidth: "2px"
    }
  },
  multiline: {
    height: "auto",
    padding: m(1),
    minHeight: "32px"
  },
  adornedStart: {
    paddingLeft: m(1)
  },
  adornedEnd: {
    paddingRight: m(1)
  },
  input: {
    padding: m(1),
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    "&::placeholder": {
      color: a.neutralDark,
      opacity: 1
    }
  },
  inputMarginDense: {
    fontSize: "0.875rem",
    paddingTop: m(1),
    paddingBottom: m(1)
  },
  notchedOutline: {
    borderColor: a.neutralBase
  }
}, Zc = {
  color: "primary",
  type: "text",
  notched: !1
}, Qc = {}, eu = {}, ru = {
  root: {
    padding: m(1),
    paddingRight: m(0.75),
    color: a.neutralDark
  },
  colorPrimary: {
    "&$disabled": {
      color: a.neutralBase
    }
  }
}, tu = {
  color: "primary",
  size: "small"
}, nu = {
  iconOutlined: {
    position: "absolute",
    right: m(1),
    pointerEvents: "none",
    color: a.black
  },
  outlined: {
    "&&": {
      paddingRight: m(8)
    }
  },
  select: {
    "&:focus": {
      backgroundColor: "transparent"
    }
  },
  icon: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  iconOpen: {
    transform: "translateY(-50%) rotate(180deg)"
  }
}, iu = {
  displayEmpty: !1,
  variant: "outlined"
}, ou = {}, au = {}, Rr = {}, su = {}, cu = {}, uu = {}, lu = {}, du = {}, fu = {}, hu = {}, pu = {}, gu = {}, vu = {
  fontSizeLarge: {
    fontSize: "2rem"
  },
  fontSizeSmall: {
    fontSize: "1rem"
  }
}, yu = {}, mu = {
  root: {
    width: 34,
    height: 20,
    padding: 0,
    margin: m(1)
  },
  colorPrimary: {
    "&$disabled": {
      "& + $track": {
        backgroundColor: a.white
      }
    }
  },
  switchBase: {
    padding: 4,
    "&$disabled": {
      "& + $track": {
        color: a.neutralBase,
        border: `1px solid ${a.neutralBase}`,
        opacity: 1
      },
      "& $thumb": {
        backgroundColor: a.neutralBase
      }
    },
    "&$checked": {
      transform: "translateX(14px)",
      color: a.white,
      padding: 2,
      "&$disabled": {
        "& + $track": {
          backgroundColor: a.neutralBase
        },
        "& $thumb": {
          backgroundColor: a.white
        }
      },
      "& + $track": {
        backgroundColor: a.primaryMain,
        opacity: 1,
        border: "none"
      },
      "& $thumb": {
        backgroundColor: a.white,
        width: 16,
        height: 16
      }
    }
  },
  sizeSmall: {
    width: 30,
    height: 16,
    padding: 0,
    "& $thumb": {
      width: 8,
      height: 8
    },
    "& $track": {
      borderRadius: 16 / 2
    },
    "& $switchBase": {
      "&$checked": {
        transform: "translateX(14px)",
        padding: 2,
        "& $thumb": {
          width: 12,
          height: 12
        }
      }
    }
  },
  thumb: {
    backgroundColor: a.neutralDark,
    opacity: 1,
    width: 12,
    height: 12
  },
  track: {
    borderRadius: 24 / 2,
    border: `1px solid ${a.neutralDark}`,
    backgroundColor: a.white,
    opacity: 1
  },
  disabled: {},
  checked: {}
}, bu = {
  color: "primary",
  size: "medium"
}, Ru = {}, Su = {}, Pu = {}, xu = {}, Cu = {}, Ou = {};
var Pr;
const Tu = {
  root: {
    lineHeight: "1.2"
  },
  head: {
    color: (Pr = oe == null ? void 0 : oe.text) == null ? void 0 : Pr.primary,
    lineHeight: "1.2",
    fontSize: "0.75rem",
    fontWeight: "normal"
  }
}, Mu = {}, ku = {}, wu = {}, Eu = {}, Au = {}, _u = {}, Iu = {}, Du = {
  root: {
    "&:last-child td": {
      borderBottom: 0
    }
  }
}, Lu = {}, Fu = {}, ju = {}, Bu = {}, $u = {}, Wu = {}, zu = {
  textColor: "primary",
  indicatorColor: "primary",
  variant: "standard",
  scrollButtons: "auto",
  centered: !1
}, Nu = {}, Vu = {
  variant: "outlined",
  SelectProps: {
    IconComponent: (i) => /* @__PURE__ */ F.jsx(ke, { fontSize: "small", ...i }),
    MenuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }
  }
}, Hu = {}, Gu = {}, Uu = {}, Ju = {}, Yu = {}, qu = {
  color: "primary"
}, Ku = {
  tooltip: {
    backgroundColor: a.white,
    color: a.black,
    borderRadius: m(1),
    maxWidth: "460px",
    padding: m(1),
    display: "flex",
    alignItems: "flex-start",
    gap: m(1),
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
  },
  tooltipArrow: {
    color: a.white
  }
}, Xu = {
  color: "primary",
  arrow: !1
}, Zu = {}, Qu = {}, el = {}, rl = {}, tl = {
  // MUI components
  MuiAccordion: Sa,
  MuiAccordionActions: xa,
  MuiAccordionDetails: Ca,
  MuiAccordionSummary: Ma,
  MuiAlert: wa,
  MuiAlertTitle: Aa,
  MuiAppBar: Ia,
  MuiAvatar: ja,
  MuiAutocomplete: La,
  MuiBackdrop: $a,
  MuiBadge: mr,
  MuiBreadcrumbs: Ka,
  MuiButton: Xa,
  MuiButtonGroup: Qa,
  MuiCard: rs,
  MuiCardActionArea: br,
  MuiCardActions: br,
  MuiCardContent: is,
  MuiCardHeader: as,
  MuiCardMedia: cs,
  MuiCheckbox: ls,
  MuiChip: fs,
  MuiCircularProgress: Rs,
  MuiContainer: Ps,
  MuiDialog: Gs,
  MuiDialogActions: Js,
  MuiDialogContent: qs,
  MuiDialogTitle: Xs,
  MuiDivider: Qs,
  MuiDrawer: rc,
  MuiFormControl: dc,
  MuiFormControlLabel: hc,
  MuiFormGroup: gc,
  MuiFormHelperText: yc,
  MuiFormLabel: bc,
  MuiGrid: Sc,
  MuiIcon: Oc,
  MuiIconButton: Mc,
  MuiInput: Ac,
  MuiInputLabel: Ic,
  MuiLink: Lc,
  MuiList: jc,
  MuiListItem: $c,
  MuiListItemIcon: zc,
  MuiListItemSecondaryAction: Vc,
  MuiListItemText: Gc,
  MuiMenu: Jc,
  MuiMenuItem: qc,
  MuiOutlinedInput: Xc,
  MuiPaper: Qc,
  MuiRadio: ru,
  MuiSelect: nu,
  MuiSnackbar: ou,
  MuiSnackbarContent: lu,
  MuiSvgIcon: vu,
  MuiSwitch: mu,
  MuiTable: Pu,
  MuiTableBody: Cu,
  MuiTableCell: Tu,
  MuiTableContainer: ku,
  MuiTableHead: Eu,
  MuiTablePagination: _u,
  MuiTableRow: Du,
  MuiTableSortLabel: Fu,
  MuiTab: Ru,
  MuiTabPanel: Bu,
  MuiTabs: Wu,
  MuiTextField: Nu,
  MuiToggleButton: Hu,
  MuiToggleButtonGroup: Uu,
  MuiToolbar: Yu,
  MuiTooltip: Ku,
  MuiTypography: el,
  // Global components
  gBanner: Na,
  gBannerActions: Ha,
  gBannerContent: Ua,
  gBannerTitle: Ya,
  gChip: ps,
  gChipBreadcumbs: vs,
  gChipIcon: ms,
  gCalendar: Cs,
  gFileDropzone: nc,
  gFileList: oc,
  gFileUploadProps: sc,
  gFooter: uc,
  gHeader: xc,
  gImagePage: wc,
  gSnackbarAlert: Rr,
  gSnackbarAlertAction: Rr,
  gSplitButton: fu,
  gStatusWrapper: pu,
  gRangeCalendar: Ws,
  gTabLabelWithBadge: mr,
  gTruncatedChips: Zu
}, nl = {}, il = {}, ol = {}, Sr = {}, al = {}, sl = {}, cl = {}, ul = {
  // MUI components
  MuiAccordion: Pa,
  MuiAccordionActions: gr,
  MuiAccordionDetails: gr,
  MuiAccordionSummary: ka,
  MuiAlert: Ea,
  MuiAlertTitle: _a,
  MuiAppBar: Da,
  MuiAvatar: Ba,
  MuiAutocomplete: Fa,
  MuiBackdrop: Wa,
  MuiBadge: za,
  MuiButton: Za,
  MuiButtonGroup: es,
  MuiCard: ts,
  MuiCardActionArea: ns,
  MuiCardActions: nl,
  MuiCardContent: os,
  MuiCardHeader: ss,
  MuiCardMedia: us,
  MuiCheckbox: ds,
  MuiChip: hs,
  MuiCircularProgress: Ss,
  MuiContainer: xs,
  MuiDialog: Us,
  MuiDialogActions: Ys,
  MuiDialogContent: Ks,
  MuiDialogTitle: Zs,
  MuiDivider: ec,
  MuiDrawer: tc,
  MuiFormControl: fc,
  MuiFormControlLabel: pc,
  MuiFormGroup: vc,
  MuiFormHelperText: mc,
  MuiFormLabel: Rc,
  MuiGrid: Pc,
  MuiIcon: Tc,
  MuiIconButton: kc,
  MuiInput: _c,
  MuiInputLabel: Dc,
  MuiLink: Fc,
  MuiList: Bc,
  MuiListItem: Wc,
  MuiListItemIcon: Nc,
  MuiListItemSecondaryAction: Hc,
  MuiListItemText: Uc,
  MuiMenu: Yc,
  MuiMenuItem: Kc,
  MuiMenuList: il,
  MuiOutlinedInput: Zc,
  MuiPaper: eu,
  MuiRadio: tu,
  MuiRadioGroup: Sr,
  MuiSelect: iu,
  MuiSnackbar: au,
  MuiSnackbarContent: du,
  MuiSvgIcon: yu,
  MuiSwitch: bu,
  MuiTable: xu,
  MuiTableBody: Ou,
  MuiTableCell: Mu,
  MuiTableContainer: wu,
  MuiTableHead: Au,
  MuiTablePagination: Iu,
  MuiTableRow: Lu,
  MuiTableSortLabel: ju,
  MuiTab: Su,
  MuiTabPanel: $u,
  MuiTabs: zu,
  MuiTextField: Vu,
  MuiToggleButton: Gu,
  MuiToggleButtonGroup: Ju,
  MuiToolbar: qu,
  MuiTooltip: Xu,
  MuiTypography: rl,
  // Global components
  gBanner: Va,
  gBannerActions: Ga,
  gBannerContent: Ja,
  gBannerTitle: qa,
  gCalendar: Os,
  gChip: gs,
  gChipBreadcumbs: ys,
  gChipIcon: bs,
  gDateCalendar: Ts,
  gDateField: Ms,
  gDateFormat: ks,
  gDateInput: ws,
  gDatePicker: Es,
  gDateRangeField: As,
  gDateRangeInput: _s,
  gDateRangePicker: Is,
  gDateTimeField: Ds,
  gDateTimeInput: Ls,
  gDateTimePicker: Fs,
  gDateTimeRangeField: js,
  gDateTimeRangeInput: Bs,
  gDateTimeRangePicker: $s,
  gFileDropzone: ic,
  gFileList: ac,
  gFileUploadProps: cc,
  gFooter: lc,
  gHeader: Cc,
  gImagePane: Ec,
  gNumberField: ol,
  gRadioGroup: Sr,
  gSnackbarAlert: su,
  gSnackbarAlertAction: cu,
  gSnackbarAlertDismiss: uu,
  gSplitButton: hu,
  gStatusWrapper: gu,
  gSwitchGroup: al,
  gTabLabelWithBadge: sl,
  gTimeField: zs,
  gTimeInput: Ns,
  gTimeRangeField: Vs,
  gTimeRangeInput: Hs,
  gTooltipTitle: cl,
  gTruncatedChips: Qu
}, ll = {
  fontFamily: ["Inter", "-apple-system", "Arial", "sans-serif"].join(","),
  htmlFontSize: 16,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    color: a.textPrimary,
    lineHeight: "2.5rem",
    fontSize: "2rem",
    fontWeight: 400
  },
  h2: {
    color: a.textPrimary,
    lineHeight: "2rem",
    fontSize: "1.5rem",
    fontWeight: 400
  },
  h3: {
    color: a.textPrimary,
    lineHeight: "1.5rem",
    fontSize: "1.25rem",
    fontWeight: 400
  },
  h4: {
    color: a.textPrimary,
    lineHeight: "1.5rem",
    fontSize: "1.125rem",
    fontWeight: 400
  },
  h5: {
    color: a.textPrimary,
    lineHeight: "1.25rem",
    fontSize: "1rem",
    fontWeight: 400
  },
  h6: {
    color: a.textPrimary,
    lineHeight: "1.125rem",
    fontSize: "0.875rem",
    fontWeight: 400
  },
  body1: {
    color: a.textPrimary,
    lineHeight: "1.5rem",
    fontSize: "1rem",
    fontWeight: 400
  },
  body2: {
    color: a.textPrimary,
    lineHeight: "1.125rem",
    fontSize: "0.875rem",
    fontWeight: 400
  },
  subtitle1: {
    color: a.textSecondary,
    lineHeight: "1.25rem",
    fontSize: "1rem",
    fontWeight: 400
  },
  subtitle2: {
    color: a.textSecondary,
    lineHeight: "1.125rem",
    fontSize: "0.875rem",
    fontWeight: 400
  },
  caption: {
    color: a.textPrimary,
    lineHeight: "1rem",
    fontSize: "0.75rem",
    fontWeight: 400
  },
  label: {
    color: a.textPrimary,
    lineHeight: "1rem",
    fontSize: "0.75rem",
    fontWeight: 400
  },
  button: {
    lineHeight: "1rem",
    fontSize: "0.875rem",
    fontWeight: 500,
    textTransform: "none"
  },
  display1: {
    fontFamily: "AvantGarde",
    lineHeight: "2.25rem",
    fontSize: "2rem",
    fontWeight: 600
  },
  display2: {
    fontFamily: "AvantGarde",
    lineHeight: "1.875rem",
    fontSize: "1.5rem",
    fontWeight: 600
  }
}, dl = {
  breakpoints: Yt,
  palette: oe,
  props: ul,
  spacing: m,
  typography: ll,
  overrides: tl,
  shape: ct
}, vl = Vt(dl);
export {
  Yt as breakpoints,
  a as colors,
  _e as elevation,
  tl as overrides,
  oe as palette,
  gl as plugins,
  ul as props,
  ct as shape,
  m as spacing,
  vl as theme,
  dl as themeOptions,
  ll as typography
};
//# sourceMappingURL=index.js.map
